import React, { useState } from "react";
import { ArrowLeft, ArrowRight, Check, Copy } from "lucide-react";

const CreativeFlow = () => {
    const [step, setStep] = useState(1);
    const [url, setUrl] = useState("");
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [copied, setCopied] = useState(false);

    const templates = [
        { id: 1, name: "Clean Beauty Layout" },
        { id: 2, name: "Shop Now Layout" },
        { id: 3, name: "Minimal Product Layout" },
        { id: 4, name: "QR Focus Layout" },
    ];

    const handleCopy = async () => {
        await navigator.clipboard.writeText('xmlData');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const data = {
        profilePicUrl: 'https://scontent-iad3-1.cdninstagram.com/v/t51.2885-19/416194152_346848634781546_3530326449501848042_n.jpg?stp=dst-jpg_e0_s150x150_tt6&efg=eyJ2ZW5jb2RlX3RhZyI6InByb2ZpbGVfcGljLmRqYW5nby4zMjAuYzIifQ&_nc_ht=scontent-iad3-1.cdninstagram.com&_nc_cat=102&_nc_oc=Q6cZ2QGuXpEuDkg168JOoHz2KvejWVLHp_UfS5To0WKSplz53rtic4p7FsXzGmKF2-2ll7U&_nc_ohc=XYTnNumLQoEQ7kNvwFXP7IS&_nc_gid=RZoCWOVAGxyv2ykrmG44yQ&edm=AOQ1c0wBAAAA&ccb=7-5&oh=00_Afuv-gPZjFkvGn0_oAL0I1D6v08TolPRO6984rU1eayltQ&oe=69A20CAD&_nc_sid=8b3546',
        username: 'nykkastore',
        ownerUsername: 'nykkastore',
        ownerFullName: 'Nykka Store',
        biography: 'Envíos en todo Santiago y regiones por starken 🚚',
        verified: true,
        followersCount: 1647,
        followsCount: 2213,
        postsCount: 200,
        caption: 'Está de vuelta éste modelo de enterito sólo en color negro, talla standard, súper elasticado , tela gruesa (algodón) no transparenta. Perfecto para ésta temporada de invierno! \n\nInfo al DM \nEntrega en toda la región metropolitana',
        videoUrl: 'https://scontent-hou1-1.cdninstagram.com/o1/v/t16/f2/m86/AQPc9wQHwL4IRicGYTNBemok_nS18uFfGXJXneoeL_C5t9TeFlXk4whIKHhOr1atc1vaD__0zTTLDU62FSJUA3UlL5rMZdi5xRYZGSo.mp4?stp=dst-mp4&efg=eyJxZV9ncm91cHMiOiJbXCJpZ193ZWJfZGVsaXZlcnlfdnRzX290ZlwiXSIsInZlbmNvZGVfdGFnIjoidnRzX3ZvZF91cmxnZW4uY2xpcHMuYzIuMzYwLmJhc2VsaW5lIn0&_nc_cat=108&vs=1178965776763004_2943550619&_nc_vs=HBksFQIYUmlnX3hwdl9yZWVsc19wZXJtYW5lbnRfc3JfcHJvZC82OTRFMEFFQkM5RjAxMTdBNzIwREZGMTUwN0JDM0Q5RF92aWRlb19kYXNoaW5pdC5tcDQVAALIARIAFQIYRmlnX3hwdl9yZWVsc19wZXJtYW5lbnRfc3JfcHJvZC84MTAzMTc0NzQ2MTY1NzhfMTA2NTY4MTI5MDA5MTU2NTI4Ni5tcDQVAgLIARIAKAAYABsAFQAAJpS5xpaQ%2BZNAFQIoAkMzLBdAIsUeuFHrhRgSZGFzaF9iYXNlbGluZV8zX3YxEQB1%2Fgdl5p0BAA%3D%3D&_nc_rid=19bcaf8636&ccb=9-4&oh=00_Afu_jxQKEo_Vb43Q0WplJk4vZSp_3x4_8lu3wqaE_J4oxg&oe=699E05D7&_nc_sid=10d13b',
    };

    return (
        <div className="min-h-screen p-10">
            <div className="bg-white rounded-3xl shadow-xl p-8 max-w-6xl mx-auto">

                {/* ================= TOP HEADER ================= */}
                <div className="flex items-center justify-between border-b pb-6 mb-8">

                    <button
                        onClick={() => setStep(step - 1)}
                        className="
                                group flex items-center gap-2
                                px-4 h-[38px]
                                bg-white
                                border border-gray-200
                                rounded-lg
                                text-gray-700
                                shadow-sm
                                hover:shadow-md
                                hover:-translate-y-[1px]
                                transition-all duration-200
                            "
                    >
                        <ArrowLeft
                            size={16}
                            className="transition-transform duration-200 group-hover:-translate-x-1"
                        />
                        <span className="text-sm font-medium">Back</span>
                    </button>

                    <div className="flex gap-10 text-sm font-medium">
                        <div className="relative">
                            <span className={step === 1 ? "text-black" : "text-gray-400"}>
                                1. Import & Upload
                            </span>
                            {step === 1 && (
                                <div className="absolute -bottom-6 left-0 w-full h-0.5 bg-black rounded-full"></div>
                            )}
                        </div>

                        <div className="relative">
                            <span className={step === 2 ? "text-black" : "text-gray-400"}>
                                2. Select Layout
                            </span>
                            {step === 2 && (
                                <div className="absolute -bottom-6 left-0 w-full h-0.5 bg-black rounded-full"></div>
                            )}
                        </div>

                        <div className="relative">
                            <span className={step === 3 ? "text-black" : "text-gray-400"}>
                                3. Look & Feel
                            </span>
                            {step === 3 && (
                                <div className="absolute -bottom-6 left-0 w-full h-0.5 bg-black rounded-full"></div>
                            )}
                        </div>

                        <div className="relative">
                            <span className={step === 4 ? "text-black" : "text-gray-400"}>
                                4. Copy XML
                            </span>
                            {step === 4 && (
                                <div className="absolute -bottom-6 left-0 w-full h-0.5 bg-black rounded-full"></div>
                            )}
                        </div>
                    </div>

                    <button
                        onClick={() => setStep(step + 1)}
                        className="
                            flex items-center gap-4
                            bg-black
                            hover:bg-gray-800
                            text-white
                            px-4
                            h-[44px]
                            rounded-[10px]
                            shadow-[0_3px_8px_rgba(0,0,0,0.12)]
                            transition-colors
                        "
                    >
                        <div className="leading-tight text-left">
                            <div className="text-[11px] opacity-90">
                                Continue to
                            </div>
                            <div className="text-[13.5px] font-semibold tracking-[0.2px]">
                                {step === 1 ? "Video Settings" : step === 2 ? "Look & Feel" : step === 3 ? "Copy XMl" : 'Finish'}
                            </div>
                        </div>

                        <div className="bg-white/25 rounded-md px-2.5 py-1.5">
                            <ArrowRight size={14} strokeWidth={2.5} />
                        </div>
                    </button>
                </div>

                {/* ================= STEP 1 ================= */}
                {step === 1 && (
                    <>
                        <div className="flex flex-col items-center">
                            {/* Input with Import inside */}
                            <div className="relative w-full max-w-3xl">
                                <input
                                    type="text"
                                    placeholder="https://instagram.com/reel/..."
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                    className="w-full border px-5 py-3 pr-32 rounded-xl focus:ring-2 focus:ring-black outline-none" />

                                <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-gray-800 text-white px-6 py-1.5 rounded-lg hover:bg-black transition">
                                    Import
                                </button>
                            </div>

                            {/* Preview Grid */}
                            {!url && (<div className="w-full max-w-3xl mt-10 grid grid-cols-4 gap-6">
                                {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                                    <div
                                        key={item}
                                        className="h-80 bg-gray-100 rounded-2xl border hover:shadow-md transition"
                                    ></div>
                                ))}
                            </div>)}

                            {url && (<div className="flex gap-10 mt-10 m-auto max-w-3xl">
                                {/* LEFT - Video/Image */}
                                <div className="w-[400px] h-[500px] bg-gray-300 rounded-2xl overflow-hidden" />

                                {/* RIGHT - Info Section */}
                                <div className="flex-1">

                                    {/* Profile Row */}
                                    <div className="flex items-center gap-4 mb-4">
                                        <div className="w-16 h-16 rounded-full bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-500 p-[2px]">
                                            <div className="w-full h-full rounded-full bg-black flex items-center justify-center text-white text-sm font-semibold">
                                                <img src={data?.profilePicUrl} crossOrigin="anonymous" />
                                            </div>
                                        </div>

                                        <div>
                                            <div className="flex items-center gap-2">
                                                <span className="font-semibold text-lg">jonesroadbeauty</span>
                                                {data?.verified && (<span className="text-blue-500">✔</span>)}
                                            </div>

                                            <div className="flex gap-6 text-sm text-gray-600 mt-1">
                                                <span><strong>{data?.postsCount}</strong> posts</span>
                                                <span><strong>{data?.followersCount}</strong> followers</span>
                                                <span><strong>{data?.followsCount}</strong> following</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Bio Section */}
                                    <div className="text-sm text-gray-700 mb-6">
                                        <p className="font-semibold">{data?.ownerFullName}</p>
                                        <p>{data?.biography}</p>
                                    </div>

                                    {/* Caption Section */}
                                    <div className="text-gray-800 leading-relaxed">
                                        <p className="mb-3">
                                            {data?.caption}
                                        </p>
                                    </div>

                                </div>
                            </div>
                            )}

                        </div>
                    </>
                )}

                {/* ================= STEP 2 ================= */}
                {step === 2 && (
                    <div>
                        <h2 className="text-xl font-semibold mb-6">
                            Select Template
                        </h2>

                        <div className="grid grid-cols-2 gap-8">
                            {templates.map((template) => (
                                <div
                                    key={template.id}
                                    onClick={() => setSelectedTemplate(template.id)}
                                    className={`relative cursor-pointer rounded-2xl p-4 transition-all duration-300
                                        ${selectedTemplate === template.id
                                            ? "border-2 border-black shadow-lg"
                                            : "border border-gray-200 hover:border-gray-400"
                                        }`}
                                >
                                    <div className="h-56 bg-gray-100 rounded-xl mb-4"></div>

                                    <p className="font-medium">{template.name}</p>

                                    {selectedTemplate === template.id && (
                                        <div className="absolute top-3 right-3 bg-black text-white rounded-full p-1">
                                            <Check size={16} />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* ================= STEP 3 ================= */}
                {step === 3 && (
                    <div className="flex flex-col items-center">

                        {/* Video Placeholder Box */}
                        <div className="w-[420px] h-[340px] rounded-2xl bg-gray-200 relative overflow-hidden shadow-lg">

                            {/* Shimmer Animation */}
                            <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200" />

                            {/* Overlay Text */}
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="text-center">
                                    <div className="w-10 h-10 border-4 border-black border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                                    <p className="font-medium text-gray-700">
                                        Generating your video...
                                    </p>
                                    <p className="text-sm text-gray-500 mt-1">
                                        This may take a few seconds
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                )}

                {step === 4 && (
                    <div className="py-12 flex justify-center">
                        <div className="w-[800px] bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.08)] p-8">

                            {/* Title */}
                            <h2 className="text-2xl font-semibold mb-2">
                                Step 4: Export XML
                            </h2>
                            <p className="text-gray-500 mb-6">
                                Copy the generated XML and use it in your rendering system.
                            </p>

                            {/* XML Box */}
                            <div className="relative">
                                <pre className="bg-gray-50 border border-gray-200 rounded-xl p-5 text-sm text-gray-800 overflow-auto max-h-[300px]">
                                    {''}
                                </pre>

                                {/* Copy Button */}
                                <button
                                    onClick={handleCopy}
                                    className="absolute top-1 right-3 flex items-center gap-2 bg-black text-white px-3 py-1.5 rounded-lg text-sm hover:bg-gray-800 transition"
                                >
                                    {copied ? (
                                        <>
                                            <Check size={14} />
                                            Copied
                                        </>
                                    ) : (
                                        <>
                                            <Copy size={14} />
                                            Copy
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CreativeFlow;